import WindowLayer from "@/components/windowLayer";
import Applayout from "@/layout/Applayout";
import { lazy } from "react";
// import Login from "@/auth/Login";
// import ForgotPassword from "@/auth/forgot-password/page";
const ErrorPage = lazy(() => import("@/layout/ErrorPage"));
const Dashboard = lazy(() => import("@/pages/Dashboard"));
const Products = lazy(() => import("@/pages/product/Products"));
const Category = lazy(() => import("@/pages/product/Category"));
const PartMaterial = lazy(() => import("@/pages/product/PartMaterial"));
const Clients = lazy(() => import("@/pages/sales/Clients"));
const Order = lazy(() => import("@/pages/sales/Order"));
const Challans = lazy(() => import("@/pages/sales/Challans"));
const Quotations = lazy(() => import("@/pages/sales/Quotations"));
const Proforma = lazy(() => import("@/pages/sales/Proforma"));
const Dealers = lazy(() => import("@/pages/purchase/Dealers"));
const PurchaseOrder = lazy(() => import("@/pages/purchase/PurchaseOrder"));
const PurchaseInward = lazy(() => import("@/pages/purchase/PurchaseInward"));
const RepairingReport = lazy(() => import("@/pages/repairing/RepairingReport"));
const ViewAdvanced = lazy(() => import("@/pages/repairing/ViewAdvanced"));
const MaterialStock = lazy(() => import("@/pages/purchase/MaterialStock"));
const OrderLedger = lazy(() => import("@/pages/account/OrderLedger"));
const SalesReport = lazy(() => import("@/pages/reports/SalesReport"));
const Repairing = lazy(() => import("@/pages/repairing/Repairing"));
const Development = lazy(() => import("@/pages/development/Development"));
const PcbParts = lazy(() => import("@/pages/development/PcbParts"));
const PcbManagement = lazy(() => import("@/pages/development/PcbManagement"));
const ProducStock  = lazy(() => import("@/pages/reports/ProducStock"));
const OrderMonth  = lazy(() => import("@/pages/reports/OrderMonth"));
const PurchaseReport = lazy(() => import("@/pages/reports/PurchaseReport"));
const PurchaseOrderMonth = lazy(() => import("@/pages/reports/PurchaseOrderMonth"));

const Login = lazy(() => import("@/auth/Login"));
const ForgotPassword = lazy(() => import("@/auth/forgot-password/page"));
const Users = lazy(() => import("@/pages/users/Users"));
const UserRole = lazy(() => import("@/pages/users/UserRole"));
const Settings = lazy(() => import("@/pages/users/Settings"));

const routes = [
  {
    element: <WindowLayer />,
    errorElement: <ErrorPage />,
    children: [
      {
        index: true,
        element: <Login />,
      },
      {
        path: 'forgot-password',
        element: <ForgotPassword />,
      },
      {
        path: 'app',
        element: <Applayout />,
        errorElement: <ErrorPage />,
        children: [
          {
            index: true,
            element: <Dashboard />,
          },
          {
            path: 'dashboard/:type',
            element: <Dashboard />,
          },
          {
            path: 'products/category',
            element: <Category />,
          },
          {
            path: 'products/products',
            element: <Products />,
          },
          {
            path: 'products/part-material',
            element: <PartMaterial />,
          },
          {
            path: 'sales/clients',
            element: <Clients />,
          },
          {
            path: 'sales/challans',
            element: <Challans />,
          },
          {
            path: 'sales/sales-order',
            element: <Order />,
          },
          {
            path: 'sales/quatations',
            element: <Quotations />,
          },
          {
            path: 'sales/proforma',
            element: <Proforma />,
          },
          {
            path: 'purchase/dealers',
            element: <Dealers />,
          },
          {
            path: 'purchase/purchase-order/:type?',
            element: <PurchaseOrder />,
          },
          {
            path: 'purchase/purchase-inward',
            element: <PurchaseInward />,
          },
          {
            path: 'reports/material-stock',
            element: <MaterialStock />,
          },
          {
            path: 'account/challans',
            element: <Challans />,
          },
          {
            path: 'account/order-ledger',
            element: <OrderLedger />,
          },
          {
            path: 'reports/sales-report',
            element: <SalesReport />,
          },          
          {
            path: 'reports/sales-report/:month',
            element: <OrderMonth />,
          },      
          {
            path: 'reports/purchase-report',
            element: <PurchaseReport />
          },
          {
            path: 'reports/purchase-report/:month',
            element: <PurchaseOrderMonth />,
          },
          {
            path: 'reports/product-stock',
            element: <ProducStock />,
          },
          {
            path: 'repairing/repairing/:status?',
            element: <Repairing />,
          },
          {
            path: 'repairing/view-advanced',
            element: <ViewAdvanced />,
          },
          {
            path: 'repairing/repairing-report',
            element: <RepairingReport />,
          },
          {
            path: 'development/development',
            element: <Products />,
          },
          {
            path: 'development/development/:status?',
            element: <Products />,
          },
          {
            path: 'development/pcb-parts',
            element: <PcbParts />,
          },
          {
            path: 'development/pcb-management',
            element: <PcbManagement />,
          },
          {
            path: 'users/users',
            element: <Users />,
          },
          {
            path: 'users/user-role',
            element: <UserRole />,
          },
          {
            path: 'users/settings',
            element: <Settings />,
          },
        ],
      },
    ],
  },
];
export default routes;
